<template>
    <div class="consultation-header2">
        <div>
            <img src="@/assets/image/banner63.png" alt="" style="width:100%;margin-top: 80px">
        </div>
        <div>
        <div class="header-first">
              <div style="font-size: 40px;color: #262A47;text-align:center;margin-top:59px;margin-bottom:55px">实时通讯平台（SDK） </div>
              <div style="display:flex;flex-wrap: wrap;justify-content:space-around;margin:0 140px">
                  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div><img src="@/assets/image/101.png" alt="" style="width:132px"></div>
                      <div style="height: 20px;font-size: 20px;color: #4F4F4F;">实时音频</div>
                  </div>~
                  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div><img src="@/assets/image/102.png" alt="" style="width:132px"></div>
                      <div style="height: 20px;font-size: 20px;color: #4F4F4F;">高清视频</div>
                  </div>
                  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div><img src="@/assets/image/103.png" alt="" style="width:132px"></div>
                      <div style="height: 20px;font-size: 20px;color: #4F4F4F;">数据共享</div>
                  </div>
                  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div><img src="@/assets/image/104.png" alt="" style="width:132px"></div>
                      <div style="height: 20px;font-size: 20px;color: #4F4F4F;">即时消息</div>
                  </div>
              </div>
                <div style="display:flex;flex-wrap: wrap;justify-content:space-around;margin:0 140px;margin-top:50px">
                  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div><img src="@/assets/image/105.png" alt="" style="width:132px"></div>
                      <div style="height: 20px;font-size: 20px;color: #4F4F4F;">信令互联</div>
                  </div>
                  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div><img src="@/assets/image/106.png" alt="" style="width:132px"></div>
                      <div style="height: 20px;font-size: 20px;color: #4F4F4F;">会议管理</div>
                  </div>
                  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div><img src="@/assets/image/107.png" alt="" style="width:132px"></div>
                      <div style="height: 20px;font-size: 20px;color: #4F4F4F;">第三方融合</div>
                  </div>
                  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                      <div><img src="@/assets/image/109.png" alt="" style="width:132px"></div>
                      <div style="height: 20px;font-size: 20px;color: #4F4F4F;">全平台支持</div>
                  </div>
              </div>
          </div>
          <div class="header-send">
               <div style="font-size: 40px;color: #262A47;text-align:center;padding-top:61px;margin-bottom:55px">平台特色</div>
               <div>
                   <div style="display:flex;justify-content:center">
                       <div style="width: 530px;height: 145px;background: #FFFFFF;border: 2px solid #FFFFFF;border-radius: 5px;"> 
                           <img src="@/assets/image/111.png" alt="" style="position: relative;top: -47px;left:221px;width:88px;height:88px">
                           <div style="text-align:center;margin-top:-30px">
                               <span style="font-size: 16px;color: #393E44;"> 全平台支持</span>
                           </div>
                           <div style="text-align:center;margin-top:19px">
                               <span style="font-size: 16px;color: #858C93;"> 提供包括Windows、Android、iOS、Mac各个平台的API支持方案</span>
                           </div>
                       </div>
                       <div style="width: 530px;height: 145px;background: #FFFFFF;border: 2px solid #FFFFFF;border-radius: 5px;margin-left:60px">
                            <img src="@/assets/image/222.png" alt="" style="position: relative;top: -47px;left:221px;width:88px;height:88px">
                           <div style="text-align:center;margin-top:-30px">
                               <span style="font-size: 16px;color: #393E44;"> 功能完整</span>
                           </div>
                           <div style="text-align:center;margin-top:19px">
                               <span style="font-size: 16px;color: #858C93;"> 提供协同所需的各类常见的功能，便于实现各类协同</span>
                           </div>
                       </div>
                   </div>
                   <div style="display:flex;justify-content:center;margin-top:76px">
                       <div style="width: 530px;height: 145px;background: #FFFFFF;border: 2px solid #FFFFFF;border-radius: 5px;"> 
                           <img src="@/assets/image/333.png" alt="" style="position: relative;top: -47px;left:221px;width:88px;height:88px">
                           <div style="text-align:center;margin-top:-30px">
                               <span style="font-size: 16px;color: #393E44;"> 平台稳定</span>
                           </div>
                           <div style="text-align:center;margin-top:19px">
                               <span style="font-size: 16px;color: #858C93;"> 服务器采用Linux操作系统，支持分布式部署，稳定可扩展</span>
                           </div>
                       </div>
                       <div style="width: 530px;height: 145px;background: #FFFFFF;border: 2px solid #FFFFFF;border-radius: 5px;margin-left:60px">
                            <img src="@/assets/image/444.png" alt="" style="position: relative;top: -47px;left:221px;width:88px;height:88px">
                           <div style="text-align:center;margin-top:-30px">
                               <span style="font-size: 16px;color: #393E44;"> 无缝集成</span>
                           </div>
                           <div style="text-align:center;margin-top:19px">
                               <span style="font-size: 16px;color: #858C93;"> 可与红杉通视频会议 软硬件终端和H323/Sip无缝结合使用</span>
                           </div>
                       </div>
                   </div>
               </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header2{
        width: 100%;
        .header-first{
            height: 520px;
            width:1200px;
            margin:0 auto;
        }
        .header-send{
            height: 590px;
            background: #EBF3FE;
        }
    }
</style>